var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "settings-page-v2" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("message.settings") }],
          "show-trial-remain-day": true,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-page-v2-wrapper" },
        [
          _c("SidebarChild", {
            attrs: {
              items: _vm.SettingsMenuTypes,
              "selected-item": _vm.activeTab,
              focusActive: true,
              defaultOpen: true,
            },
            on: { selected: _vm.selectedTab },
          }),
          _vm._v(" "),
          _vm.settingInitialized
            ? _c(
                "div",
                { staticClass: "page-content" },
                [
                  _vm.upgrade.enabled && _vm.upgrade.type === "settings-overlay"
                    ? _c("UpgradeNeededPageOverlay", {
                        attrs: {
                          plan: _vm.upgrade.plan,
                          feature: _vm.upgrade.feature,
                          name: _vm.upgrade.name,
                        },
                      })
                    : _vm.activeTab === "company"
                    ? _c("Company", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "features"
                    ? _c("Features", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "language"
                    ? _c("Language", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "timings-settings"
                    ? _c("ChatTimingSettings", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "availability"
                    ? _c("Availability", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "website-integration"
                    ? _c("WebSiteIntegration", {
                        staticClass: "website-integrations",
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "developer"
                    ? _c("ApiAccess", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "visitor-attribute"
                    ? _c("ProfileFields")
                    : _vm.activeTab === "auto-assign"
                    ? _c("AutoChatAssign", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "contact-module-rules"
                    ? _c("ContactModuleRules", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "task-module-rules"
                    ? _c("TaskModuleRulesSettings")
                    : _vm.activeTab === "wallet"
                    ? _c("Wallet", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "notifications"
                    ? _c("NotificationSettings", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "audit-logs"
                    ? _c("AuditLogs", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm.activeTab === "access-control" ||
                      _vm.activeTab === "sessions"
                    ? _c("AccessControl")
                    : _vm.activeTab === "company-users"
                    ? _c("Users")
                    : _vm.activeTab === "roles"
                    ? _c("Roles", {
                        attrs: {
                          "is-edit": _vm.isRoleEdit,
                          "role-id": _vm.editRoleId,
                        },
                        on: { "route-change": _vm.handleRoleRouteChange },
                      })
                    : _vm.activeTab === "departments"
                    ? _c("Subjects")
                    : _vm.activeTab === "system-messages"
                    ? _c("WelcomeMessages")
                    : _vm.activeTab === "templates"
                    ? _c("Templates")
                    : _vm.activeTab === "tags"
                    ? _c("Tags")
                    : _vm.activeTab === "forbidden-inputs"
                    ? _c("BannedWords")
                    : _vm.activeTab === "banned-visitors"
                    ? _c("BannedVisitors")
                    : _vm.activeTab === "copilot-prompts"
                    ? _c("CoPilotPrompts", {
                        attrs: {
                          "save-copilot-prompts": _vm.saveCopilotPromptsOnly,
                        },
                      })
                    : _vm.activeTab === "billing"
                    ? _c("Billing")
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }